import React from 'react'

import {IDeviceVideoStream} from '@containers/video/videoStreams/types'
import {useQueryState} from '@hooks/query/useQueryState'
import ResizableBox from '@ui/resizeBox/ResizeBox'
import styles from '@containers/video/videoStreams/list/sx'
import DraggableModalWithoutPortal from '@ui/modal/draggableModal/DraggableModalWithoutPortal'
import {useMedia} from '@hooks/ui/useMedia'
import {DeviceCameraPlayerContent} from '@containers/video/videoStreams/cameraPlayer/DeviceCameraPlayerContent'
import BaseModal from '@ui/modal/BaseModal'
import IconButtonCustom from '@ui/buttons/iconButtonCustom/IconButtonCustom'
import CloseIcon from '@mui/icons-material/Close'
import {SxType} from '@baseTypes/sx/sxTypes'


const DEFAULT_WIDTH = typeof window !== 'undefined' ? Math.min(960, window.innerWidth - 80) : 960
const DEFAULT_HEIGHT = Math.round(DEFAULT_WIDTH * 9 / 16)

const sx: SxType = {
	close: {
		right:'5px',
		top:'5px',
		zIndex:555,
		position: 'absolute',
	}
}
export const DeviceCameraPlayer = ({
									   devices,
									   open,
									   onClose,
									   cameraSrc,
									   onChangeChangeSrc,
									   deviceName,
								   }: {
	devices: IDeviceVideoStream[]
	open: boolean
	onClose: () => void
	cameraSrc: string | null
	onChangeChangeSrc: (cameraSrc: string | null) => void
	deviceName:string | null
}) => {
	
	const {isDesktop} = useMedia()
	const [width, setWidth] = useQueryState<number>('width', DEFAULT_WIDTH, {
		parse: (value) => Number(value)
	})
	const [height, setHeight] = useQueryState<number>('height', DEFAULT_HEIGHT, {
		parse: (value) => Number(value)
	})
	
	if (!isDesktop) {
		return (
			<BaseModal
				open={open}
				onClose={onClose}
				sx={{
					width: '95vw',
					height: 'calc(97vh - 50px)',
					position: 'relative',
					bottom:'5px',
				}}
			>
				<IconButtonCustom
					onClick={onClose}
					sx={sx.close}
				>
					<CloseIcon />
				</IconButtonCustom>
				<DeviceCameraPlayerContent
					devices={devices}
					cameraSrc={cameraSrc}
					onChangeChangeSrc={onChangeChangeSrc}
				/>
			</BaseModal>
		)
	}
	
	return (
		<DraggableModalWithoutPortal
			onClose={onClose}
			open={open}
			title={deviceName || undefined}
		>
			<ResizableBox
				width={width}
				setWidth={setWidth}
				height={height}
				setHeight={setHeight}
				buttonPositionsSx={styles.buttonPositionsSx}
				buttonPositionsIconSx={styles.buttonPositionsIconSx}
			>
				<DeviceCameraPlayerContent
					devices={devices}
					cameraSrc={cameraSrc}
					onChangeChangeSrc={onChangeChangeSrc}
				/>
			</ResizableBox>
		</DraggableModalWithoutPortal>
	)
}